import { createSlice } from '@reduxjs/toolkit';
import accountThunk from './middleware';
// States
import accountState from './state';
// Types
import { AccountReducers } from './types';

const accountSlice = createSlice({
    name: 'account',
    initialState: accountState,
    reducers: {
        setUser(state, action) { state.user = action.payload; },
        setAccountNo(state, action) { state.accountNo = action.payload; },
        setTradingStatus(state, action) { state.tradingStatus = action.payload },
        setLoginInformations(state, action) { state.loginInformations = action.payload },
        setTradingViewTimeZone(state, action) { state.tradingViewTimeZone = action.payload },
        setTradingPlatformAvailable(state, action) { state.tradingPlatformAvailable = action.payload }
    } as AccountReducers,
    extraReducers(builder) {
        accountThunk.addLoginInformationsCase(builder);
    },
});

export default accountSlice;